/* eslint-disable @next/next/no-img-element */
import { levels } from "@/data/serviceLevel";
import { structuredData } from "@/data/structuredData";
import useWindowSize from "@/hooks/useWindowSize";
import styles from "@/styles/Services.module.scss";
import { getServiceLevels, imageLocalization } from "@/utils/helpers";
import { getStrapiMedia } from "@/utils/media";
import { fetchAPI } from "@/utils/strapi";
import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState, useContext } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import { GlobalContext } from "@/components/context/Global";
import L1TemplateI from "@/components/L1TemplateI";
import L1TemplateC from "@/components/TemplateC/L1TemplateC";
import L1TemplateM from "@/components/L1TemplateM/L1TemplateM";
const Layout = dynamic(() => import("@/components/Layout"));
const StructuredData = dynamic(() => import("@/components/StructuredData"));
const Breadcrumbs = dynamic(() => import("@/components/Breadcrumbs"));
const CaseStudies = dynamic(() => import("@/components/CaseStudies"));
const Contact = dynamic(() => import("@/components/Contact"));
const Testimonial = dynamic(() => import("@/components/Testimonial"));
const WhyChoose = dynamic(() => import("@/components/WhyChoose"));

const Application = ({ serviceLevels }: any) => {
  const router = useRouter();
  const [refresh, setRefresh] = useState<boolean>(false);
  const { userCountry } = useContext<any>(GlobalContext);
  const { attributes } = serviceLevels;
  const {
    OurServices,
    ServiceBanner,
    ServiceLevel1SEO,
    Technologies,
    WhyChooseUs,
    WhyCubetFor,
    Slug,
    Banner,
    OurPartnerships,
    ServiceLevel2SEO,
    SubServices,
    WhyCubet,
    MainService,
    Categories,
    Template,
    MainTitle
  } = attributes;
  const [width] = useWindowSize();

  const updatedL2Service1 = {
    ...structuredData.l2Service1,
    name: MainTitle,  // Dynamic title
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/services/${Slug}/`,
    description: ServiceLevel2SEO?.MetaDescription,  // Dynamic description
    image: Banner?.Banner?.data?.attributes?.url,
    mainEntity: {
      ...structuredData.l2Service1.mainEntity,
      name: MainTitle,  // Dynamic mainEntity title
      serviceType: Banner?.Title,  // Dynamic serviceType
    }
  };
  const updatedL2Service3 = {
    ...structuredData.l2Service3,
    itemListElement: structuredData.l2Service3.itemListElement.map((item, index) => {
      if (index === 1) { // Position 2
        return {
          ...item,
          item: {
            ...item.item,
            "@id": `${process.env.NEXT_PUBLIC_BASE_URL}/services/${MainService?.data?.attributes?.Slug}/`,
            name: MainService?.data?.attributes?.ServiceBanner?.Title || "Default Service Title", // Dynamic title
          },
        };
      } else if (index === 2) { // Position 3
        return {
          ...item,
          item: {
            ...item.item,
            "@id": `${process.env.NEXT_PUBLIC_BASE_URL}/services/${Slug}/`,
            name: Slug || "Default Slug", // Dynamic slug
          },
        };
      }
      return item;
    }),
  };
  useEffect(() => {
    const handleRouteChange = (url: string) => {
      setRefresh(true);
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  const getServiceImg = (item: any) => {
    const localizationImg = imageLocalization[userCountry];
    if(localizationImg && item[localizationImg]?.data){
      return (
        <img
          src={getStrapiMedia(item[localizationImg])}
          alt={
            item[localizationImg]?.data?.attributes?.alternativeText ||
            item?.Title
          }
          style={{ objectFit: "cover" }}
          className="img-fluid enhance-img w-100"
          height={item[localizationImg]?.data?.attributes?.height}
          width={item[localizationImg]?.data?.attributes?.width}
          // priority
        />
      );
    }else{
      return (
        <img
          src={getStrapiMedia(item?.Image)}
          alt={item?.Image?.data?.attributes?.alternativeText || item?.Title}
          style={{ objectFit: "cover" }}
          className="img-fluid enhance-img w-100"
        />
      );
    }
  };
  const getImage = (ServiceBanner: any) => {
    const localizationImg = imageLocalization[userCountry];
    if(localizationImg && ServiceBanner?.ServiceBannerLocalization){
      const ImageExists =
        ServiceBanner?.ServiceBannerLocalization[localizationImg];
      return (
        <>
          {ImageExists && ImageExists?.data?.attributes ? (
            <Image
              src={getStrapiMedia(ImageExists)}
              alt={
                ImageExists?.data?.attributes?.alternativeText ||
                ServiceBanner?.Title
              }
              style={{ objectFit: "cover", height: "100%" }}
              height={ImageExists?.data?.attributes?.height}
              width={ImageExists?.data?.attributes?.width}
              className="d-lg-block img-fluid  mb-lg-0"
            />
          ) : (
            <Image
              src={getStrapiMedia(ServiceBanner?.Banner)}
              alt={
                ServiceBanner?.Banner?.data?.attributes?.alternativeText ||
                ServiceBanner?.Title
              }
              style={{ objectFit: "cover", height: "100%" }}
              className="d-lg-block img-fluid  mb-lg-0"
              height={ServiceBanner?.Banner?.data?.attributes?.height}
              width={ServiceBanner?.Banner?.data?.attributes?.width}
            />
          )}
        </>
      );
    } else {
      return (
        <Image
          src={getStrapiMedia(ServiceBanner?.Banner)}
          alt={
            ServiceBanner?.Banner?.data?.attributes?.alternativeText ||
            ServiceBanner?.Title
          }
          style={{ objectFit: "cover", height: "100%" }}
          className="d-lg-block img-fluid  mb-lg-0"
          height={ServiceBanner?.Banner?.data?.attributes?.height}
          width={ServiceBanner?.Banner?.data?.attributes?.width}
        />
      );
    }
  };
  return getServiceLevels(Slug) === "l2" ? (
    <Layout
      title={ServiceLevel2SEO?.MetaTitle}
      description={ServiceLevel2SEO?.MetaDescription}
      ogTitle={ServiceLevel2SEO?.OGTitle}
      ogDescription={ServiceLevel2SEO?.OGDescription}
      ogImage={Banner?.Banner?.data?.attributes?.url}
      footerType="banner"
      banner={true}
      bannerClass="home-banner"
    >
      <StructuredData
        data={[updatedL2Service1, structuredData.l2Service2, updatedL2Service3]}
      />
      <div className={styles.webApp}>
        <div className="header">
          <Container>
            <Row>
              <Col md={10} lg={7}>
                <Breadcrumbs
                  breadcrumbs={[
                    {
                      label:
                        MainService?.data?.attributes?.ServiceBanner?.Title,
                      url: MainService?.data?.attributes?.Slug,
                    },
                    {
                      label: Slug.replaceAll("-", " "),
                      url: null,
                    },
                  ]}
                />
                <h1>{Banner?.Title}</h1>
                <p className="normal-text mt-0 mt-md-3 mb-0 servicel1-sub">
                  {Banner?.SubTitle}
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="why">
          <Container>
            <Row className="justify-content-between shadow-lg">
              {Banner?.Banner?.data?.attributes?.url && (
                <Col lg>
                  {/* <Image
                    src={getStrapiMedia(Banner.Banner)}
                    width={Banner?.Banner?.data?.attributes?.width}
                    height={Banner?.Banner?.data?.attributes?.height}
                    priority={true}
                    alt={
                      Banner?.Banner?.data?.attributes?.alternativeText ||
                      Banner?.Title
                    }
                    style={{ objectFit: "cover", height: "100%" }}
                    className="img-fluid"
                  /> */}
                  {/* <img
                    src={getStrapiMedia(Banner.Banner)}
                    alt={
                      Banner?.Banner?.data?.attributes?.alternativeText ||
                      Banner?.Title
                    }
                    style={{ objectFit: "cover", height: "100%" }}
                    className="img-fluid"
                  /> */}
                  {getImage(Banner)}
                </Col>
              )}
              <Col lg={6}>
                <div className="why-container why-link">
                  <h2 className="mt-md-5 mt-lg-0">{WhyCubet?.Title}</h2>
                  <ReactMarkdown className="normal-text mt-4">
                    {WhyCubet?.Description}
                  </ReactMarkdown>
                  <ul>
                    {WhyCubet?.Highlights?.map((item: any, index: number) => (
                      <React.Fragment key={item.id}>
                        <li>{item?.Title}</li>
                        {index !== WhyCubet?.Highlights?.length - 1 && (
                          <li>&nbsp;</li>
                        )}
                      </React.Fragment>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {SubServices?.ListInFrontEnd && (
          <div className="enhance">
            <Container>
              <Row className="align-items-center justify-content-between">
                <Col lg={6}>
                  <h3>{SubServices?.Title}</h3>
                </Col>
                <Col lg={6}>
                  <p className="normal-text">{SubServices?.Description}</p>
                </Col>
              </Row>
            </Container>
            {SubServices?.Collection?.length > 0 && (
              <Container className=" nav-tab" style={{ marginTop: '80px' }}>
                <Row>
                  <Col className="d-none d-lg-block desktop-enhance">
                    <Tab.Container defaultActiveKey="0">
                      <Row className="gx-5 justify-content-center">
                        <div className="col-sm col-lg-12">
                          <Nav style={{ gap: '40px', padding: '0px 40px', display: 'flex', justifyContent: 'center' }} variant="pills">
                            {SubServices?.Collection?.map(
                              (item: any, index: number) => (
                                <Nav.Item key={item.id}>
                                  <Nav.Link className="desktop-nav" eventKey={index.toString()}>
                                    {item?.Title}
                                  </Nav.Link>
                                </Nav.Item>
                              )
                            )}
                          </Nav>
                        </div>

                        {/* <Col lg={12} className="mb-md-5 mb-lg-0">
                          <Nav variant="pills" className="flex-column">
                            {SubServices?.Collection?.map(
                              (item: any, index: number) => (
                                <Nav.Item key={item.id}>
                                  <Nav.Link eventKey={index.toString()}>
                                    {item?.Title}
                                  </Nav.Link>
                                </Nav.Item>
                              )
                            )}
                          </Nav>
                        </Col> */}
                        <Col lg={12} style={{ marginTop: '80px' }}>
                          <Tab.Content>
                            {SubServices?.Collection?.map(
                              (item: any, index: number) => (
                                <Tab.Pane
                                  eventKey={index.toString()}
                                  key={item.id}
                                >
                                  <div className="container">
                                    <div className="row">
                                      <div className="col-lg-7">
                                        {getServiceImg(item)}
                                      </div>
                                      <div className="col-lg-5 d-flex align-items-center">
                                        <div className="para">
                                          <p>{item?.ShortDescription}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </Tab.Pane>
                              )
                            )}
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </Col>
                  <Col className="d-lg-none">
                    <Tab.Container defaultActiveKey="0">
                      <Row className="gx-5">
                        <Col lg={4} className="mb-md-5 mb-lg-0">
                          <Nav variant="pills" className="flex-column">
                            {SubServices?.Collection?.map(
                              (item: any, index: number) => (
                                <Nav.Item key={item.id}>
                                  <Nav.Link eventKey={index.toString()}>
                                    {item?.Title}
                                  </Nav.Link>
                                </Nav.Item>
                              )
                            )}
                          </Nav>
                        </Col>
                        <Col lg>
                          <Tab.Content>
                            {SubServices?.Collection?.map(
                              (item: any, index: number) => (
                                <Tab.Pane
                                  eventKey={index.toString()}
                                  key={item.id}
                                >
                                  <div className="content">
                                    <p>{item?.ShortDescription}</p>
                                  </div>
                                  <>{getServiceImg(item)}</>
                                </Tab.Pane>
                              )
                            )}
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </Col>
                </Row>
              </Container>
            )}
          </div>
        )}
        {OurPartnerships?.ListInFrontEnd && (
          <div className="partnership">
            <Container>
              <Row>
                <Col xs={12}>
                  <h4 className="heading mb-5">{OurPartnerships?.Title}</h4>
                </Col>
                {OurPartnerships?.Collection?.map((item: any) => (
                  <Col xs={12} key={item.id}>
                    <div className="single">
                      <Row className="align-items-center">
                        {item?.Image?.data?.id && (
                          <Col>
                            {/* <Image
                              src={getStrapiMedia(item?.Image)}
                              width={item?.Image?.data?.attributes?.width}
                              height={item?.Image?.data?.attributes?.height}
                              priority={false}
                              alt={
                                item?.Image?.data?.attributes
                                  ?.alternativeText || item?.Title
                              }
                              style={{ objectFit: "contain" }}
                              className="img-fluid mb-4 mb-lg-0 first"
                            /> */}
                            <img
                              src={getStrapiMedia(item?.Image)}
                              alt={
                                item?.Image?.data?.attributes
                                  ?.alternativeText || item?.Title
                              }
                              style={{ objectFit: "contain" }}
                              className="img-fluid mb-4 mb-lg-0 first"
                            />
                          </Col>
                        )}
                        <Col lg={8}>
                          <h5>{item?.Title}</h5>
                          <p className="normal-text">
                            {item?.ShortDescription}
                          </p>
                          {item?.LinkUrl && (
                            <Link prefetch={false} href={item?.LinkUrl}>
                              {item?.LinkTitle}
                              <Image
                                src="/assets/icons/arrow-right-circle-new.svg"
                                width={24}
                                height={24}
                                priority={false}
                                alt={item?.Title}
                                style={{ objectFit: "contain" }}
                                className="img-fluid ms-2"
                              />
                            </Link>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}
              </Row>
            </Container>
          </div>
        )}
        <CaseStudies
          categoryId={serviceLevels?.id}
          refresh={refresh}
          level={2}
        />
        <Testimonial
          country={
            userCountry === "countryNotFound" ? null : userCountry || null
          }
        />
        <WhyChoose data={WhyChooseUs} />
        <div className="services-contact">
          <Contact
            title="Contact Us"
            type="contact"
            country={
              userCountry === "countryNotFound" ? null : userCountry || null
            }
          />
        </div>
      </div>
    </Layout>
  ) : (
    <>
      {" "}
      {(Template === "TemplateI" ||
        Template === null ||
        Template === undefined) && (
          <L1TemplateI
            ServiceLevel1SEO={ServiceLevel1SEO}
            ServiceBanner={ServiceBanner}
            getImage={getImage}
            WhyCubetFor={WhyCubetFor}
            attributes={attributes}
            OurServices={OurServices}
            serviceLevels={serviceLevels}
            refresh={refresh}
            Technologies={Technologies}
            WhyChooseUs={WhyChooseUs}
            Slug={Slug}
            Categories={Categories}
            width={width}
            userCountry={userCountry}
            MainTitle={MainTitle}
          />
        )}
      {Template === "TemplateM" && (
        <div>
          <L1TemplateM
            ServiceLevel1SEO={ServiceLevel1SEO}
            ServiceBanner={ServiceBanner}
            getImage={getImage}
            WhyCubetFor={WhyCubetFor}
            attributes={attributes}
            OurServices={OurServices}
            serviceLevels={serviceLevels}
            refresh={refresh}
            Technologies={Technologies}
            WhyChooseUs={WhyChooseUs}
            Slug={Slug}
            Categories={Categories}
            width={width}
            userCountry={userCountry}
            MainTitle={MainTitle}
          />
        </div>
      )}
      {Template === "TemplateC" && (
        <div>
          <L1TemplateC
            ServiceLevel1SEO={ServiceLevel1SEO}
            ServiceBanner={ServiceBanner}
            getImage={getImage}
            WhyCubetFor={WhyCubetFor}
            attributes={attributes}
            OurServices={OurServices}
            serviceLevels={serviceLevels}
            refresh={refresh}
            Technologies={Technologies}
            WhyChooseUs={WhyChooseUs}
            Slug={Slug}
            Categories={Categories}
            width={width}
            userCountry={userCountry}
            MainTitle={MainTitle}
          />
        </div>
      )}
    </>
  );
};

export async function getStaticPaths() {
  return {
    paths: levels.map((article: any) => ({
      params: {
        slug: article.slug,
      },
    })),
    // headers: {
    //   'Cache-Control': 'no-store', // Disable caching for this page
    // },
    fallback: "blocking",
  };
}

export async function getStaticProps({ params }: any) {
  const articlesRes = await fetchAPI(
    getServiceLevels(params.slug) === "l1" ? "/service-l1s" : "/service-l2s",
    {
      filters: {
        Slug: params.slug,
      },
      populate: "deep",
    }
  );
  // console.log('errr',articlesRes)
  return {
    props: { serviceLevels: articlesRes.data[0] },
    revalidate: 60, // Rebuilds the page every 60 seconds if data changes

  };
}


export default Application;
